<template>
  <div>
    <Card class="p-no-shadow-app">
      <template #title>Informação da Entidade</template>
      <template #content>
        <div class="p-grid">
          <div class="p-col-12 p-md-4">
            <p><strong>Nome:</strong> {{ entityInfo?.name }}</p>
            <p><strong>Morada:</strong> {{ entityInfo?.address }}</p>
            <p><strong>Código Postal:</strong> {{ entityInfo?.zip_code }}</p>
            <p><strong>Localidade:</strong> {{ entityInfo?.city }}</p>
            <p><strong>NIF:</strong> {{ entityInfo?.nif }}</p>
          </div>
          <div class="p-col-12 p-md-4">
            <p><strong>Telefone:</strong> {{ entityInfo?.telephone }}</p>
            <p><strong>Telemóvel:</strong> {{ entityInfo?.tlmvl }}</p>
            <p><strong>Email:</strong> {{ entityInfo?.email }}</p>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
export default {
  name: "EntityInfo",
  props: {
    patId: {
      type: Number,
      required: true,
    },
    entityInfo: {
      type: Object,
      required: false,
    },
  },
  components: {},
  data() {
    return {
      loading: false,
    };
  },
  computed: {},
  async mounted() {},
  methods: {},
};
</script>
